import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import router from "../router/index.js";

Vue.use(Vuex);

import modSeguridad from "./modSeguridad/index";
import axios from "axios";
const PUBLIC_ROUTE_NAMES = [
  "LoginForm",
  "epayco",
  "ForgotPassword",
  "ResetPassword",
  "tratamiento-datos-personales",
  "terminos-condiciones-tarjetas",
  "DatosTarjetasForm",
  "conecta-sabana",
  "conecta-sabana-home",
  "comprar-tarjeta",
  "usuarios-ext-comprar-tarjeta",
  "bloquear-tarjeta",
  "usuarios-ext-bloquear-tarjeta",
  "usuarios-ext-reposicion-tarjeta",
  "consultar-solicitudes",
  "usuarios-ext-consultar-solicitudes",
];


axios.defaults.withCredentials = true;
axios.defaults.baseURL =
  process.env.VUE_APP_API_URL; /* "http://eaead65417dc.ngrok.io/"; */
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Manejar el error aquí
    if (error.response) {
      // La solicitud fue realizada, pero el servidor respondió con un código de estado fuera del rango 2xx

      const status = error.response.status;

      if (status === 401) {
        // this.dispatch("logout");
        // console.error("Status:", error.response.status);

        let excludedRoutes = PUBLIC_ROUTE_NAMES;

        // Obtener la ruta actual
        let currentPath = router.currentRoute.path;

        // Si la ruta actual es null o undefined, asignarle el valor de "/"
        if (!currentPath) {
          currentPath = "/";
          excludedRoutes.push("/");
        }

        if (currentPath == "/") {
          excludedRoutes.push("/");
        } else {
          excludedRoutes = excludedRoutes.filter((r) => r !== "/");
        }

        // Verificar si la ruta actual está en las rutas excluidas
        if (!excludedRoutes.some((ruta) => currentPath.includes(ruta))) {
          alert("Su sesión ha caducado, por favor vuelva a ingresar");
          window.location.href = "/LoginForm";
        }
      }
    } else if (error.request) {
      // La solicitud fue realizada pero no se recibió respuesta
      //console.error('Request:', error.request);
    } else {
      // Algo sucedió en la configuración de la solicitud que desencadenó un error
      //console.error('Error:', error.message);
    }
    //console.error('Config:', error.config);

    // Retornar una promesa rechazada
    return Promise.reject(error);
  }
);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: null,
    errors: null,
    mensaje_login: null,
    auth: false,
    permissions: [],
    menus: [],
    routes: [],
    accessToken: "",
    darkMode: false,
  },
  getters: {
    isAuthenticated: (state) => {
      return state.auth;
    },
    getPermissions: (state) => {
      return state.permissions;
    },
    getRoutes: (state) => {
      return state.routes;
    },
    getMenus: (state) => {
      return state.menus;
    },
    getUser: (state) => {
      return state.user;
    },
    getErrors: (state) => {
      return state.errors;
    },
    getMensajeLogin: (state) => {
      return state.mensaje_login;
    },

    getDarkMode: (state) => {
      return state.darkMode;
    },

    can: (state) => (permissionName) => {
      return (
        state.permissions.find((per) => per.name === permissionName) !==
        undefined
      );
    },
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    SET_USER(state, user) {
      state.user = user;
      state.auth = Boolean(user);
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    },
    SET_MENUS(state, menus) {
      state.menus = menus;
    },
    SET_ROUTES(state, routes) {
      state.routes = routes;
    },
    SET_ERRORS(state, error) {
      state.errors = error;
    },
    SET_MENSAJE_LOGIN(state, mensaje) {
      state.mensaje_login = mensaje;
    },

    SET_DARK_MODE(state, value) {
      state.darkMode = Boolean(value);
    },
  },
  actions: {
    setDarkMode({ commit }, value) {
      commit("SET_DARK_MODE", value);
    },
    async login({ dispatch, commit }, credentials) {
      await axios.get("/sanctum/csrf-cookie");
      await axios
        .post("/login", credentials)
        .then(async (res) => {
          await dispatch("getUser");
          await dispatch("getPermissions");
          await dispatch("getMenus");
          await dispatch("getRoutes", this.getters.getMenus);
          await dispatch("setRoutes");
        })
        .catch(async (error) => {
          let res = await Object.assign({}, error);

          let err_pss_date = res.response.data.errors.password_updated_at;
          //let err_recaptcha = res.response.data.errors.recaptcha;
          //let err_status = res.response.data.errors.status;
          let err_email = res.response.data.errors.email;
          if (typeof err_pss_date !== "undefined") {
            let errors = "password_updated_at";
            commit("SET_ERRORS", errors);
          }
          /*if (typeof err_recaptcha !== "undefined") {
            let errors = "recaptcha";
            commit("SET_ERRORS", errors);
          }
          if (typeof err_status !== "undefined") {
            let errors = "status";
            commit("SET_ERRORS", errors);
          } */
          if (typeof err_email !== "undefined") {
            let errors = "email";
            let mensaje =
              "Los datos ingresados no coinciden, por favor comuníquese con un administrador";
            commit("SET_ERRORS", errors);
            commit("SET_MENSAJE_LOGIN", mensaje);
          }
        });
    },
    async getUser({ commit }) {
      await axios
        .get("/api/user")
        .then((res) => {
          commit("SET_USER", res.data);
        })
        .catch(() => {
          commit("SET_USER", null);
        });
    },

    async logout({ dispatch }) {
      await axios.post("/logout");
      await dispatch("getMenus", null);
      await dispatch("getPermissions");
      await dispatch("getUser");
    },

    async getPermissions({ commit }) {
      await axios
        .get("/api/user/permissions")
        .then((res) => {
          commit("SET_PERMISSIONS", res.data);
        })
        .catch(() => {
          commit("SET_PERMISSIONS", []);
        });
    },

    async getMenus({ commit }) {
      await axios
        .get("/api/menu")
        .then((response) => {
          commit("SET_MENUS", response.data);
        })
        .catch(() => {
          commit("SET_MENUS", []);
        });
    },

    async getRoutes({ commit }, menus) {
      var r = [];
      menus.forEach((menu) => {
        menu.nivel2.forEach((nivel2) => {
          nivel2.rutas.forEach((ruta) => {
            r.push(ruta);
          });
        });
      });
      /* console.log(r); */
      commit("SET_ROUTES", r);
    },

    async setRoutes() {
      this.getters.getRoutes.forEach((dataRoutes) => {
        var newRoute = {
          path: dataRoutes.path,
          component: () => import("../views/" + dataRoutes.component + ".vue"),
          name: dataRoutes.name,
        };
        router.addRoutes([newRoute]);
      });
    },
  },
  modules: {
    modSeguridad: modSeguridad,
  },
});
